import MUIDrawer from '@mui/material/Drawer'
import { FC } from 'react'

import { DrawerProps } from './drawer.types'

export const Drawer: FC<DrawerProps> = ({ children, ...props }) => {
  return <MUIDrawer {...props}>{children}</MUIDrawer>
}
